module.exports = __webpack_public_path__ + "img/videoArt.7d90948b.svg";